import { useState } from 'react';

import { formatHours, stopRowEvent } from './helpers';
import { HoursStepper } from './HoursStepper';
import type { HoursCellProps } from './types';

// The bill's quarter-hour stepper, saved as soon as a figure settles; the new
// figure shows while the server answers, and the saved one comes back on failure.
export function HoursCell({ clientName, bucket, value, previous, extra, onSave }: HoursCellProps) {
  const [pending, setPending] = useState<number | null>(null);

  const commit = (hours: number) => {
    setPending(hours);
    onSave(hours)
      .catch(() => {})
      .finally(() => setPending(null));
  };

  return (
    <span
      onClick={stopRowEvent}
      onKeyDown={stopRowEvent}
      className="flex w-28 flex-col items-end gap-0.5"
    >
      <HoursStepper
        label={`${clientName} ${bucket} hours`}
        value={pending ?? value}
        min={0}
        onCommit={commit}
        className="w-full"
      />
      {/* Always drawn, so saving a figure never changes the row's height. */}
      <span className="text-xs tabular-nums text-text-tertiary">
        Last month {formatHours(previous)}
      </span>
      {extra > 0 && (
        <span className="text-xs tabular-nums text-text-tertiary">
          +{formatHours(extra)} extra this month
        </span>
      )}
    </span>
  );
}
